import React from 'react'
import ReactDOM from 'react-dom/client';
import './index.css';
import TTest from './TTest';
import PageCreate from "./PageCreate";
import Root from "./Root";
import Header from "./Header";
import PageShow from "./PageShow";
import Generateds from "./Generateds";
export {default} from 'react_ujs';
// export {TTest};


declare global {
    var Components: {};
    var Constants: Map<string, string>;
}

global.Components = {TTest,PageCreate,Root,Header,PageShow,Generateds};

// interface Window {
//     TTest: () => string;
// }

// interface globalThis {
//     TTest: () => string;
// }

// global.TTest = TTest;
// const TTTest = TTest;

// const root = ReactDOM.createRoot(
//     document.getElementById('root') as HTMLElement
// );
// root.render(
//     <React.StrictMode>
//         <TTest />
//     </React.StrictMode>
// );

// import {type global} from './global'
